import styled from "styled-components";
import BottomBar from "./components/BottomBar";
import { useUgla3dModel, useUgla3dStateManager, Viewer } from "@ugla-france/ugla-3d-library";
import { useEffect, useState } from "react";
import Viewer360 from "./components/viewer360";

interface LayoutProps {
    initialKitchen: string;
}

const Layout: React.FC<LayoutProps> = ({ initialKitchen }) => {

    const stateManager = useUgla3dStateManager();
    const modele = useUgla3dModel();
    const [open, setOpen] = useState('close');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentColor, setCurrentColor] = useState('#B27B65FF');
    const [currentPov, setCurrentPov] = useState(1);
    const [scale, setScale] = useState(0.8);
    const [showEqui, setShowEqui] = useState(false);
    const [currentKitchen] = useState(initialKitchen);

    useEffect(() => {
        console.log("current pov selected", currentPov);
    }, [currentPov]);
    
    useEffect(() => {
        const handleResize = () => {
        // Adjust the scale based on screen width
        // You can customize the logic here
        if (window.innerWidth <= 2000) {
            setScale(0.8); // Medium scale for tablets
        } else {
            setScale(1); // Default scale for larger screens
        }
        };

        // Call the function initially
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        const currentAsset = modele.getContent().assets.filter((asset) => {
            const nameTag = asset.tags?.find((tag) => tag.key === 'name');
            return nameTag?.value === currentKitchen;
        }).filter((asset) => {
            const colorTag = asset.tags?.find((tag) => tag.key === 'color');
            return colorTag?.value === currentColor;
        }).filter((asset) => {
            const povTag = asset.tags?.find((tag) => tag.key === 'pov');
            return povTag?.value === currentPov.toString();
        }).find((asset) => {
            const stateTag = asset.tags?.find((tag) => tag.key === 'state');
            return stateTag?.value === open;
        })
        if (currentAsset) {
            stateManager.addObject({ id: "main", asset: currentAsset });
        }
        console.log("current state in useeffect", open, currentColor, currentPov, currentKitchen);
        console.log(currentAsset);
    }, [open, modele, stateManager, currentColor, currentPov, currentKitchen]);
    const handleColorChange = (color: string) => {
        setCurrentColor(color);
    };
    const handleOpenState = (state: string) => {
        setOpen(state);
    }
    const BottomBarState = (state?: string) => {
        if (!state) return;
        if (state) {
            console.log("State changed to:", state);
            handleOpenState(state);
        }

    }
    const BottomColorStateChange = (color?: string) => {
        if (color) {
            console.log("Color changed to:", color);
            handleColorChange(color);
        }
    }
    const equiStateChange = (equi: boolean) => {
        handleViewerChange(equi);
    }
    const handleViewerChange = (equi: boolean) => {
        setShowEqui(equi);
    }
    const handlePovChange = (pov: number) => {
        setCurrentPov(pov);
    }
    const handleCarouselClick = () => {
        setShowEqui(false);
    }
    const handleClickOnNext = (side: string) => {
        const nextAsset = modele.getContent().assets.filter((asset) => {
            const nameTag = asset.tags?.find((tag) => tag.key === 'name');
            return nameTag?.value === currentKitchen;
        }).filter((asset) => {
            const stateTag = asset.tags?.find((tag) => tag.key === 'state');
            return stateTag?.value === open;
        }).filter((asset) => {
            const colorTag = asset.tags?.find((tag) => tag.key === 'color');
            return colorTag?.value === currentColor;
        })

        if (!nextAsset || nextAsset.length === 0) return;

        let newIndex: number;

        if (side === "left") {
            newIndex = currentIndex > 0 ? currentIndex - 1 : nextAsset.length - 1;
        } else {
            newIndex = currentIndex < nextAsset.length - 1 ? currentIndex + 1 : 0;
        }

        setCurrentIndex(newIndex);
        const povValue = nextAsset[newIndex].tags?.find(tag => tag.key === 'pov')?.value || '1';
        const parsedPov = parseInt(povValue, 10);
        setCurrentPov(isNaN(parsedPov) ? 1 : parsedPov);
        stateManager.removeObject('main');
        stateManager.addObject({ id: "main", asset: nextAsset[newIndex] });
    };
    return (
        <Container>
        <ContentWrapper>
        <MainContent>
            {
                        showEqui ?
                            <Viewer360 url={currentKitchen === 'Campagne' ? 'https://store.fms.staging.ugla.tech/public/demoFBD/360_kitchen_campagne.png' : 'https://store.fms.staging.ugla.tech/public/demoFBD/360_kitchen_Brooklyn.png'}></Viewer360> :
                            <Viewer scale={scale} disableInstancing={true} />
            }
            <ArrowButton direction="left" onClick={() => handleClickOnNext("left")} />
            <ArrowButton direction="right" onClick={() => handleClickOnNext("right")} />
        </MainContent>
            <BottomBar onStateChange={BottomBarState} onColorStateChange={BottomColorStateChange} on360Change={equiStateChange} onPovChange={handlePovChange} onCarouselClick={handleCarouselClick} currentKitchen={currentKitchen} />
                
        </ContentWrapper>
        </Container>
    );
};


// Styled components
const Container = styled.div`
    display: flex;
    height: 100vh;
    width: 100%;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const MainContent = styled.div`
    position: relative;
    overflow: hidden;
    flex: 1;
    background-color: #f0f0f0;
    // background-image:
    // linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px),
    // linear-gradient(90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px);
    background-size: 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10%;
    padding-right: 10%;
    
    img {
        display: block;
    }
`;

const ArrowButton = styled.div<{ direction: "left" | "right" }>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ direction }) => (direction === "left" ? "left: 2rem;" : "right: 2rem;")}
    width: 3rem;
    height: 3rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 10;

    &:hover {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    &::before {
        content: "";
        width: 1rem;
        height: 1rem;
        border-top: 2px solid #333;
        border-right: 2px solid #333;
        transform: ${({ direction }) =>
            direction === "left" ? "rotate(225deg)" : "rotate(45deg)"};
        transition: all 0.3s ease;
    }
`;

export default Layout;